module.exports = __webpack_public_path__ + "static/media/TN-Women-Tops-2.0_OptionAll.ddfd53db.svg";